<template>
  <div>
      <main-header></main-header>
      <div class="page">
        <div class="w1200">
          <div class="newspage-top">
            <div class="left">
              <h1>{{title}}</h1>
              <span>{{time}}</span>
            </div>
            <div class="right" @click="back">
              {{language[languagetype].back}}
            </div>
          </div>
          <div class="newspage-content" v-html="content">
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import MainHeader from './header'
import Fetch from '../js/ajaxa'
let languagetext = require('../js/newspage.json')
export default {
  name: 'about',
  data () {
    return {
      title: '',
      time: '',
      content: '',
      lang: 1,
      language: {},
      languagetype: 'cn'
    }
  },
  methods: {
    back: function () {
      this.$router.back(-1)
    }
  },
  components: {
    MainHeader
  },
  created () {
    const that = this
    that.language = languagetext
    that.lang = sessionStorage.getItem('lang') || 1
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
  },
  beforeCreate () {
    const that = this
    that.id = this.$route.params.id
    Fetch.post('Api/detailed', {
      id: that.id
    }).then((res) => {
      that.title = res.title
      that.time = res.update_time
      that.content = res.content
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .pagebanner1{height: 400px;overflow: hidden;background: url("../assets/banner.jpg") center 0 no-repeat;}
  .page{min-height: 600px;box-sizing: border-box;padding: 0 0 50px 0;background-color: #f6f6f6;}
  .newspage-top{width: 100%;height: auto;overflow: hidden;}
  .newspage-top .left{width: 980px;float: left;}
  .newspage-top .right{width:auto;float: right;font-size: 16px;color: #999999;cursor: pointer;margin-top: 60px;background:url("../assets/backbtn.png") 0 center no-repeat;padding-left: 27px;}
  .newspage-top .left h1{line-height: 48px;display: block;margin-top: 31px;font-size: 30px;color: #333333;}
  .newspage-top .left span{display: block;line-height: 34px;font-size: 15px;color: #999999;}
  .newspage-content{width: 100%;height: auto;overflow: hidden}
</style>



// WEBPACK FOOTER //
// src/page/newspage.vue